import alt from '../alt';
import Immutable from 'seamless-immutable';
import {seamlessImmutable, seamlessBootstrap} from 'epic-alt-utils/index';
import {datasource} from 'alt-utils/lib/decorators';
import SubscriptionActions from '../actions/SubscriptionActions';
import SubscriptionSource from '../sources/SubscriptionSource';

@datasource(SubscriptionSource)
@seamlessImmutable
class SubscriptionStore {
    constructor() {
        this.on('error', (error) => {console.error(error);});
        this.on('bootstrap', seamlessBootstrap.bind(this, null));
        this.state = Immutable({
            isSubscribed: false
        });
        this.bindActions(SubscriptionActions);
    }

    onSubscribeEmail() {
        if (this.state.isSubscribed) return false;
        return this.getInstance().subscribeEmail();
    }

    onSubscribeEmailSuccess(response) {
        if (response.status === 200 && !response.data.errorCode) {
            this.setState(this.state.merge({
                isSubscribed: true
            }));
        } else {
            console.error('Subscribe Email failed!');
        }
    }

    onSubscribeEmailFailure(error) {
        console.error('Subscribe Email failed!', error);
    }
}

export default alt.createStore(SubscriptionStore, 'SubscriptionStore');
